import React from 'react';
import styled from 'styled-components';
import FooterCol from './FooterCol';
import PText from './PText';

const FooterStyle = styled.div`
  background-color: var(--deep-dark);
  padding-top: 10rem;
  .container {
    display: flex;
    gap: 3rem;
  }
  .footer__col1 {
    flex: 2;
  }
  .footer__col2,
  .footer__col3,
  .footer__col4 {
    flex: 1;
  }
  .footer__col1__title {
    font-size: 3.5rem;
    margin-bottom: 1rem;
  }
  .copyright {
    background-color: var(--dark-bg);
    text-align: left;
    padding: 1rem 0;
    margin-top: 5rem;
    .para {
      margin-left: 0;
    }
  }
  @media only screen and (max-width: 768px) {
    .container {
      flex-direction: column;
      gap: 0rem;
      & > div {
        margin-top: 5rem;
      }
    }
    .footer__col1 .para {
      max-width: 100%;
    }
    .copyright {
      .container {
        div {
          margin-top: 0;
        }
      }
    }
  }
`;

export default function Footer() {
  return (
    <FooterStyle>
      <div className="container">
        <div className="footer__col1">
          <h1 className="footer__col1__title">Will Freittas</h1>
          <PText>
            Web designer e desenvolvedor Com foco na construção de aplicações e
            sites com designs exclusivos e com uma boa taxa de desempenho.
          </PText>
        </div>
        <div className="footer__col2">
          <FooterCol
            heading="Navegação"
            links={[
              {
                title: 'Home',
                path: '/',
                type: 'Link',
              },
              {
                type: 'Link',
                title: 'About',
                path: '/about',
              },
              {
                type: 'Link',
                title: 'Projects',
                path: '/projects',
              },
              {
                type: 'Link',
                title: 'Contact',
                path: '/contact',
              },
            ]}
          />
        </div>
        <div className="footer__col3">
          <FooterCol
            heading="Informações de contato"
            links={[
              {
                title: '+5531999694300',
                path: 'tel:+5531999694300',
              },
              {
                title: 'afreittaswill@gmail.com',
                path: 'mailto:afreittaswill@gmail.com',
              },
              {
                title: 'Letícia, Belo Horizonte - MG Brasil',
                path: 'https://goo.gl/maps/81H9ZDLwVZjKpu9F7',
              },
            ]}
          />
        </div>
        <div className="footer__col4">
          <FooterCol
            heading="social Links"
            links={[
              {
                title: 'Linkedin',
                path: 'https://www.linkedin.com/in/will-freittas/',
              },
              {
                title: 'GitHub',
                path: 'https://github.com/WdvOps',
              },
              {
                title: 'Instagram',
                path: 'http://instagram.com',
              },
            ]}
          />
        </div>
      </div>
      <div className="copyright">
        <div className="container">
          <PText>
            © 2021 - e-Will | Designed By{' '}
            <a
              target="_blank"
              rel="noreferrer"
              href="https://e-will-portifolio.vercel.app/"
            >
              Will Freittas
            </a>{' '}
          </PText>
        </div>
      </div>
    </FooterStyle>
  );
}
